import { FC, useCallback, useMemo } from "react";
import Select from "react-select";
import {
  SearchConditionGroupResponse,
  SearchConditionValueEntity,
} from "@/web-client";
import {
  ReactSelectPlaceholder,
  ReactSelectStyles,
} from "@/consts/ReactSelect";

interface SearchConditionGroupPullDownOnSpProps {
  searchConditionGroup: SearchConditionGroupResponse;
  selectedIds: number[];
  onChange: (
    to: { value: number; label: string },
    from: { value: number; label: string },
  ) => void;
}

export const SearchConditionGroupPullDownOnSp: FC<
  SearchConditionGroupPullDownOnSpProps
> = ({
  searchConditionGroup: { label, values },
  selectedIds,
  onChange,
}): JSX.Element => {
  // パラメーターから現在選択されている詳細検索項目を取得
  const selectedValue = useMemo<SearchConditionValueEntity | undefined>(() => {
    return values.find(({ id }) => selectedIds.includes(id));
  }, [values, selectedIds]);

  // プルダウンを変更した時のハンドラ
  const changeSelectHandler = useCallback(
    (to) => {
      onChange(
        to,
        selectedValue
          ? { value: selectedValue.id, label: selectedValue.label }
          : undefined,
      );
    },
    [onChange, selectedValue],
  );

  // 選択可能な項目
  const options = useMemo(() => {
    return [
      { value: 0, label: "選択なし" },
      ...values.map(({ id, label }) => {
        return {
          value: id,
          label,
        };
      }),
    ];
  }, [values]);

  return (
    <div>
      <Select
        instanceId={label}
        options={options}
        defaultValue={
          selectedValue
            ? { value: selectedValue.id, label: selectedValue.label }
            : null
        }
        onChange={changeSelectHandler}
        styles={ReactSelectStyles}
        placeholder={ReactSelectPlaceholder}
      />
    </div>
  );
};
